// ======================================================================
// FILE:
// src/modules/service_crm/feedback/components/FeedbackTable.js
//
// MODULE:
// Service CRM
//
// FEATURE:
// Feedback Queue Table
// ======================================================================

import React from "react";

export default function FeedbackTable({

  rows = [],

  loading = false,

  onAdd,

  onEdit,

  onView,

}) {

  const renderStatus = (
    status
  ) => {

    const bg =
      status === "COMPLETED"
        ? "#198754"
        : "#fd7e14";

    return (

      <span

        style={{

          background: bg,

          color: "#fff",

          padding:
            "4px 10px",

          borderRadius: 12,

          fontSize: 12,
        }}
      >
        {status}
      </span>

    );
  };

  return (

    <div

      style={{

        background: "#fff",

        borderRadius: 14,

        overflow: "hidden",

        boxShadow:
          "0 2px 8px rgba(0,0,0,0.08)",
      }}
    >

      <div
        className="table-responsive"
      >

        <table
          className="table table-hover mb-0"
        >

          <thead
            className="table-light"
          >

            <tr>

              <th>
                Ticket No
              </th>

              <th>
                Customer
              </th>

              <th>
                Engineer
              </th>

              <th>
                Resolved Date
              </th>

              <th>
                Feedback %
              </th>

              <th>
                Status
              </th>

              <th
                style={{
                  width: 220,
                }}
              >
                Actions
              </th>

            </tr>

          </thead>

          <tbody>

            {loading && (

              <tr>

                <td
                  colSpan="7"
                  className="text-center"
                >
                  Loading...
                </td>

              </tr>

            )}

            {!loading &&
              rows.length === 0 && (

              <tr>

                <td
                  colSpan="7"
                  className="text-center"
                >
                  No Records Found
                </td>

              </tr>

            )}

            {!loading &&
              rows.map((row) => (

              <tr
                key={
                  row.ticket_id
                }
              >

                <td>
                  {row.ticket_no}
                </td>

                <td>
                  {row.customer_name}
                </td>

                <td>
                  {row.assigned_engineer}
                </td>

                <td>

                  {row.resolved_at
                    ? new Date(
                        row.resolved_at
                      ).toLocaleDateString()
                    : "-"}

                </td>

                <td>

                  {row.feedback_percentage
                    ? `${row.feedback_percentage}%`
                    : "-"}

                </td>

                <td>

                  {renderStatus(
                    row.feedback_status
                  )}

                </td>

                <td>

                  <div
                    style={{
                      display:
                        "flex",
                      gap: 8,
                    }}
                  >

                    {row.feedback_status ===
                    "PENDING" ? (

                      <button

                        className="
btn btn-sm btn-primary"

                        onClick={() =>
                          onAdd(row)
                        }
                      >
                        Add
                      </button>

                    ) : (

                      <>

                        <button

                          className="
btn btn-sm btn-info"

                          onClick={() =>
                            onView(row)
                          }
                        >
                          View
                        </button>

                        <button

                          className="
btn btn-sm btn-warning"

                          onClick={() =>
                            onEdit(row)
                          }
                        >
                          Edit
                        </button>

                      </>

                    )}

                  </div>

                </td>

              </tr>

            ))}

          </tbody>

        </table>

      </div>

    </div>
  );
}